import { array, boolean, defineAction, number, object, string } from '~/prix'
import indicatorTrendsAction from './indicatorTrends.action.json'

const indicatorTrendsDefinition = defineAction({
  ...indicatorTrendsAction,
  operation: 'read' as const,
  input: object({
    currentDate: string().isOptional(),
    stateAbbreviation: string().isOptional(),
  }),
  output: object({
    items: array(
      object({
        displayOrder: number(),
        key: string(),
        title: string(),
        value: number(),
        variationPercentage: number().isOptional(),
        variationRelation: string(),
        sourceType: string(),
        sourceKey: string().isOptional(),
        productDescription: string().isOptional(),
        latestPeriodStartDate: string().isOptional(),
        latestPeriodEndDate: string().isOptional(),
        previousPeriodStartDate: string().isOptional(),
        previousPeriodEndDate: string().isOptional(),
        hasCurrentAndPrevious: boolean(),
      }),
    ),
  }),
})

export default indicatorTrendsDefinition
